// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/binding.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { TaskView } from "./task";
import { TaskExpandMask } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.ListRelatedTasksRequest
 */
export interface ListRelatedTasksRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1;
     */
    referenceTaskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.ListRelatedTasksResponse
 */
export interface ListRelatedTasksResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1;
     */
    list: TaskView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountRelatedTasksRequest
 */
export interface CountRelatedTasksRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1;
     */
    referenceTaskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountRelatedTasksResponse
 */
export interface CountRelatedTasksResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListRequest
 */
export interface TaskBindingServiceListRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest
 */
export interface TaskBindingServiceListByReferenceTaskRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1;
     */
    referenceTaskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBinding
 */
export interface TaskBinding {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 3;
     */
    task?: TaskView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView referenced_task = 4;
     */
    referencedTask?: TaskView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskRelationship relationship = 5;
     */
    relationship: TaskRelationship;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingView
 */
export interface TaskBindingView {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskBinding item = 1;
     */
    item?: TaskBinding;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListResponse
 */
export interface TaskBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskBindingView list = 1;
     */
    list: TaskBindingView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskRelationship
 */
export enum TaskRelationship {
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_CREATED_TASK = 1;
     */
    CREATED_TASK = 1,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_CREATED_BY_TASK = 2;
     */
    CREATED_BY_TASK = 2,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_SUPERSEDED_BY = 3;
     */
    SUPERSEDED_BY = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ListRelatedTasksRequest$Type extends MessageType<ListRelatedTasksRequest> {
    constructor() {
        super("c1.api.task.v1.ListRelatedTasksRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListRelatedTasksRequest
 */
export const ListRelatedTasksRequest = new ListRelatedTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRelatedTasksResponse$Type extends MessageType<ListRelatedTasksResponse> {
    constructor() {
        super("c1.api.task.v1.ListRelatedTasksResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListRelatedTasksResponse
 */
export const ListRelatedTasksResponse = new ListRelatedTasksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountRelatedTasksRequest$Type extends MessageType<CountRelatedTasksRequest> {
    constructor() {
        super("c1.api.task.v1.CountRelatedTasksRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountRelatedTasksRequest
 */
export const CountRelatedTasksRequest = new CountRelatedTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountRelatedTasksResponse$Type extends MessageType<CountRelatedTasksResponse> {
    constructor() {
        super("c1.api.task.v1.CountRelatedTasksResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountRelatedTasksResponse
 */
export const CountRelatedTasksResponse = new CountRelatedTasksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListRequest$Type extends MessageType<TaskBindingServiceListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListRequest
 */
export const TaskBindingServiceListRequest = new TaskBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListByReferenceTaskRequest$Type extends MessageType<TaskBindingServiceListByReferenceTaskRequest> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest
 */
export const TaskBindingServiceListByReferenceTaskRequest = new TaskBindingServiceListByReferenceTaskRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBinding$Type extends MessageType<TaskBinding> {
    constructor() {
        super("c1.api.task.v1.TaskBinding", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "task", kind: "message", T: () => TaskView },
            { no: 4, name: "referenced_task", kind: "message", T: () => TaskView },
            { no: 5, name: "relationship", kind: "enum", T: () => ["c1.api.task.v1.TaskRelationship", TaskRelationship, "TASK_RELATIONSHIP_"] },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBinding
 */
export const TaskBinding = new TaskBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingView$Type extends MessageType<TaskBindingView> {
    constructor() {
        super("c1.api.task.v1.TaskBindingView", [
            { no: 1, name: "item", kind: "message", T: () => TaskBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingView
 */
export const TaskBindingView = new TaskBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListResponse$Type extends MessageType<TaskBindingServiceListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListResponse
 */
export const TaskBindingServiceListResponse = new TaskBindingServiceListResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskBindingService
 */
export const TaskBindingService = new ServiceType("c1.api.task.v1.TaskBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: TaskBindingServiceListRequest, O: TaskBindingServiceListResponse },
    { name: "ListByReferenceTask", options: { "authz.method": { role: "VIEWER" } }, I: TaskBindingServiceListByReferenceTaskRequest, O: TaskBindingServiceListResponse },
    { name: "ListRelatedTasks", options: { "authz.method": { role: "VIEWER" } }, I: ListRelatedTasksRequest, O: ListRelatedTasksResponse },
    { name: "CountRelatedTasks", options: { "authz.method": { role: "VIEWER" } }, I: CountRelatedTasksRequest, O: CountRelatedTasksResponse }
]);
